export default __webpack_public_path__ + "static/media/HP-LogoMain.af30d42e.png";